export default "__VITE_ASSET__DlBXhYli__"